import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, filter } from 'rxjs';
import { DEFAULT_LANGUAGE } from 'src/app/core/language';
import { UpdateWatcherService } from './services/update-watcher.service';
import { SessionGuardService } from './services/session-guard.service';
import { ThemeService } from './services/theme.service';

/** Las pantallas sin sesión: sin barra lateral. */
const AUTH_URLS = ['/login', '/register', '/reset'];

export function isAuthUrl(url: string): boolean {
  return AUTH_URLS.some((auth) => url === auth || url.startsWith(`${auth}/`) || url.startsWith(`${auth}?`));
}

/**
 * Desde la fase 0b la app es solo web: no hay arranque nativo (push de Cordova, barra de
 * estado, splash, boton atras de Android). El aviso de pedido nuevo que disparaba la push
 * en primer plano vuelve con la alerta de la comanda (fase 1) y el push web (fase 2).
 *
 * Al arrancar, vigila si se publico una version nueva (`UpdateWatcherService`).
 */
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent implements OnDestroy {
  /** La barra lateral de PC: no en las pantallas sin sesión. */
  showNav = false;
  /** El comercio de la sesión, para la barra lateral. `null` sin barra. */
  uid: string | null = null;
  private routerSubscription: Subscription;

  constructor(
    private translate: TranslateService,
    private updates: UpdateWatcherService,
    router: Router,
    theme: ThemeService,
    session: SessionGuardService
  ) {
    this.routerSubscription = router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.showNav = !isAuthUrl(event.urlAfterRedirects);
        this.uid = this.showNav ? localStorage.getItem('uid') : null;
      });
    // Unico lugar donde se decide el idioma inicial. login.page forzaba 'spanish' en su
    // constructor y esto ponia 'en': cual ganaba dependia del orden de construccion.
    const language = localStorage.getItem('language') ?? DEFAULT_LANGUAGE;
    localStorage.setItem('language', language);
    this.translate.use(language);
    this.updates.start();
    theme.init();
    //  Un solo observador de la sesión: una cuenta suspendida con la comanda abierta se cierra (NV-31).
    session.start();
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }
}
